<template>
  <div class="container alturaMinima">
    <Jumbotron urlImage="../../assets/layout/images/nuestras-instalaciones.jpg" :title="$t('messages.ourInstallations')"
      :subtitle="$t('messages.ourInstallationsDescription')" />
    <div class="p-grid wrapper">
      <div class="p-md-5 data-container">
        <h5>
          {{ $t("messages.ourServices").toUpperCase() }}
        </h5>
        <h1>
          {{ $t("messages.equipment") }}
        </h1>
        <ul class="lista-sitios">
          <li v-for="item in items" :key="item">{{ item }}</li>
        </ul>
      </div>
      <div class="p-md-7">
        <GaleriaComponent :images="images" />
      </div>
    </div>
  </div>
</template>

<script>
import Jumbotron from "./layout/jumbotron_main.vue";
import GaleriaComponent from "./layout/galeria.vue";
export default {
  name: "Instalaciones",
  components: {
    GaleriaComponent,
    Jumbotron,
  },
  data() {
    return {
      images: [
        {
          itemImageSrc: "./assets/layout/gallery/sala-cirugia-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/sala-cirugia-1-t.jpg",
          texto: "messages.surgeryRooms",
        },
        {
          itemImageSrc: "./assets/layout/gallery/sala-medicos-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/sala-medicos-1-t.jpg",
          texto: "messages.doctorsRooms",
        },
        {
          itemImageSrc: "./assets/layout/gallery/esterilizacion-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/esterilizacion-1-t.jpg",
          texto: "messages.steril",
        },
        {
          itemImageSrc: "./assets/layout/gallery/farmacia-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/farmacia-1-t.jpg",
          texto: "messages.pharmacy",
        },
        {
          itemImageSrc: "./assets/layout/gallery/cafeteria-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/cafeteria-1-t.jpg",
          texto: "messages.cafeteria",
        },
        {
          itemImageSrc: "./assets/layout/gallery/recuperacion-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/recuperacion-1-t.jpg",
          texto: "messages.recoveryRooms",
        },
        {
          itemImageSrc: "./assets/layout/gallery/pasillo-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/pasillo-1-t.jpg",
          texto: "messages.recoveryRooms",
        },
        {
          itemImageSrc: "./assets/layout/gallery/vestier-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/vestier-1-t.jpg",
          texto: "messages.dressingRoom",
        },
        {
          itemImageSrc: "./assets/layout/gallery/recepcion-1.jpg",
          thumbnailImageSrc: "./assets/layout/gallery/recepcion-1-t.jpg",
          texto: "messages.reception",
        },
      ]
    }
  }, 
  computed: {
    items() {
      const translates = {
        es: [
          "Aire acondicionado y flujo laminar",
          "Maquinas de anestesia de ultima generación",
          "Torres de endoscopia",
          "Microscopio",
          "Excelente iluminación",
          "Control de humedad",
          "Temperatura automatizada",
          "Salas de médicos",
          "Centro de esterilización",
          "Farmacia",
          "Cafetería",
          "Parqueadero para Cirujanos",
          "Parqueadero para pacientes y acompañantes",
          "Salas de recuperación",
          "Baños para personas con dificultad en movilidad",
          "Recepción",
          "Ubicación Estratégica Geográfica",
        ],
        en: [
          "Air conditioning and laminar flow",
          "Latest generation anesthesia machines",
          "Endoscopy towers",
          "Microscope",
          "Excellent lighting",
          "Humidity control",
          "Automated temperature",
          "Doctor's offices",
          "Sterilization center",
          "Pharmacy",
          "Cafeteria",
          "Parking for Surgeons",
          "Parking for patients and companions",
          "Recovery rooms",
          "Bathrooms for people with mobility difficulties",
          "Reception",
          "Strategic Geographic Location",
        ],
        fr: [
          "Climatisation et flux laminaire",
          "Dernières machines d'anesthésie génération",
          "Tours d'endoscopie",
          "Microscope",
          "Excellente éclairage",
          "Contrôle de l'humidité",
          "Température automatisée",
          "Salles de médecins",
          "Centre de stérilisation",
          "Pharmacie",
          "Cafétéria",
          "Parking pour les chirurgiens",
          "Parking pour les patients et les accompagnateurs",
          "Salles de récupération",
          "Salles de bains pour les personnes à mobilité réduite",
          "Réception",
          "Emplacement géographique stratégique",
        ]
      };
      return translates[this.$i18n.locale];
    },
  },
  metaInfo: {
    title: 'Instalaciones - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Instalaciones - QualityCare',
        content: 'Se muestran las instalaciones de QualityCare, el centro de cirugía plástica que le brinda la mejor experiencia medico - paciente.',
      },
    ],
  }
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #ffffff;
}

.wrapper {
  padding: 20px 300px;
}

.data-container {
  ul {
    font-size: 18px;
    padding: 0px;

    li {
      margin-top: 5px;
    }
  }
}

h1,
h5 {
  color: #083078;
  font-weight: bolder;
}

h1 {
  font-size: 55px;
}

.lista-sitios {
  margin-top: 20px;
  font-weight: bolder;
}

.boton-enlace {
  text-align: center;
  background-color: #083078;
  padding: 10px 0px;
  color: white;
  user-select: none;
  width: fit-content;
  height: fit-content;
  border-radius: 3px;
  margin-top: 40px;
  transition: 0.5s all;

  a {
    color: white;
    font-size: 16px;
    width: 100%;
    padding: 10px 20px;
  }
}

.boton-enlace:hover {
  background-color: #2B86D9;
}

@media screen and (max-width: 1400px) {
  .wrapper {
    padding: 20px 10px;
  }
}

@media screen and (max-width: 600px) {
  .data-container {
    text-align: center;
  }

  .lista-sitios {
    margin-top: 5px;
  }
}

/* nuevos*/
/* #bannerNuevo {
  overflow: hidden;
  min-height: 500px;
  margin: 1em auto;
  background: #f1f1f1;
}

#bannerNuevo #column1Nuevo {
  padding: 100px 30px 20px 30px;
  color: #ffffff;
}

#bannerNuevo #column1Nuevo h2 {
  padding: 0px 0px 20px 0px;
  letter-spacing: -1px;
  font-size: 30px;
  font-weight: 400;
} */

/** PAGE */

/** CONTENT */

/* #content h2 {
  padding: 0px 0px 20px 0px;
  letter-spacing: -2px;
  text-shadow: 1px 1px 1px #ffffff;
  font-size: 40px;
  font-weight: 400;
}

#content h3 {
  margin-top: -15px;
  padding: 0px 0px 5px 0px;
  font-size: 14px;
} */

/** SIDEBAR */
/* 
#sidebar h2 {
  padding: 0px 0px 20px 0px;
  letter-spacing: -1px;
  text-shadow: 1px 1px 1px #ffffff;
  font-size: 30px;
  font-weight: 400;
} */

/*Nuevo*/

/* .product-item {
  .product-item-content {
    border-radius: 3px;
    margin-top: 0px;
    text-align: center;
    padding: 2rem 0;
    padding-top: 0px;
  }
  .product-image {
    width: 100%;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  }
}

@media (max-width: 1900px) {
  .product-item {
    .product-image {
      width: 60%;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    }
  }
}

@media (max-width: 766px) {
  #bannerNuevo {
    min-height: 320px;
  }
  .product-item {
    .product-item-content {
      border-radius: 3px;
      margin-top: 0px;
      text-align: center;
      padding: 2rem 0;
      padding-top: 0px;
    }
    .product-image {
      width: 100%;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    }
  }
} */
</style>
